/*
  Melo cart-line offers. Event-delegated from document, so it survives the
  drawer re-rendering itself (the buttons are replaced on every redraw; a
  listener bound to them directly would die after the first change).

  After any successful change the drawer is told via `cart:update` — the event
  name the vendor drawer listens for. See snippets/melo-cart-offer.liquid for
  why detail.data must always be present.
*/
(function () {
  if (window.__meloCartOffer) return;          // loaded once per page
  window.__meloCartOffer = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'That did not work.');
        return j;
      });
    });
  }

  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      // itemCount matters: the header cart icon reads it and treats a missing
      // value as 0, which hid the bubble after every offer change (v60).
      detail: { resource: cart, sourceId: 'melo-cart-offer', data: { source: 'melo-cart-offer', itemCount: cart.item_count } }
    }));
  }

  // The drawer redraws the whole line after a change, so the control the
  // shopper just used is destroyed and focus falls to <body>. Put it back on
  // the same line's offer (its first control) once the redraw lands.
  function refocus(btn) {
    var line = btn.dataset.line;
    var old = btn;
    var tries = 0;
    (function look() {
      var cell = line && document.querySelector('[data-melo-coffer] [data-line="' + line + '"]');
      if (cell && cell !== old && cell.isConnected) {
        var box = cell.closest('[data-melo-coffer]');
        var first = box && box.querySelector('select, button, a[href]');
        if (first && !old.isConnected) { first.focus(); return; }
      }
      if (++tries < 25) setTimeout(look, 120);
    })();
  }

  function busy(btn, on) {
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function say(btn, text) {
    var id = btn.getAttribute('aria-describedby');
    var el = id && document.getElementById(id);
    if (el) el.textContent = text;
  }

  function finish(btn, job) {
    return job.then(function (cart) {
      say(btn, 'Done.');
      announce(cart);
      refocus(btn);
    }).catch(function (err) {
      busy(btn, false);
      say(btn, err.partial
        ? 'The 12 Pack is in your cart, but the 4 Pack could not be removed. Remove it if you do not want both.'
        : err.message + ' Your cart has not changed.');
    });
  }

  // Setting or clearing a selling plan: Shopify requires the LINE NUMBER here,
  // not the line key, and always the quantity. null clears the plan.
  function setPlan(el, planId) {
    return post('cart/change.js', {
      line: parseInt(el.dataset.line, 10),
      quantity: parseInt(el.dataset.qty, 10),
      selling_plan: planId
    });
  }

  // Frequency picker on a not-yet-subscribed line: keep the button's price in
  // step with the plan chosen. Nothing is sent until the button is pressed.
  document.addEventListener('change', function (e) {
    var pick = e.target.closest('[data-melo-coffer-plan]');
    if (pick) {
      var opt = pick.options[pick.selectedIndex];
      var box = pick.closest('[data-melo-coffer]');
      var total = box && box.querySelector('[data-melo-coffer-total]');
      if (total && opt && opt.dataset.total) total.textContent = opt.dataset.total;
      return;
    }
    // Frequency picker on a subscribed line: applies straight away. A select
    // that changes the cart on change is fine here because it is announced
    // (status message) and nothing moves focus away from it.
    var chg = e.target.closest('[data-melo-coffer-change]');
    if (chg) {
      busy(chg, true);
      say(chg, 'Updating your cart…');
      finish(chg, setPlan(chg, parseInt(chg.value, 10)));
    }
  });

  document.addEventListener('click', function (e) {
    var sub = e.target.closest('[data-melo-coffer-subscribe]');
    var up  = e.target.closest('[data-melo-coffer-upgrade]');
    var one = e.target.closest('[data-melo-coffer-onetime]');
    if (!sub && !up && !one) return;
    e.preventDefault();                          // belt and braces: never submit the cart form
    var btn = sub || up || one;
    if (btn.disabled) return;
    busy(btn, true);
    say(btn, 'Updating your cart…');

    if (sub) {
      var box = btn.closest('[data-melo-coffer]');
      var pick = box && box.querySelector('[data-melo-coffer-plan]');
      var planId = pick ? parseInt(pick.value, 10) : NaN;
      if (!planId) { busy(btn, false); say(btn, 'Choose how often first.'); return; }
      finish(btn, setPlan(btn, planId));
      return;
    }
    if (one) {
      finish(btn, setPlan(btn, null));
      return;
    }

    // ADD FIRST, then remove. If the add fails the 4 Pack is still there;
    // doing it the other way round could leave the shopper with nothing.
    var added = false;
    finish(btn, post('cart/add.js', {
      items: [{ id: parseInt(btn.dataset.toVariant, 10), quantity: parseInt(btn.dataset.qty, 10) }]
    }).then(function () {
      added = true;
      return post('cart/change.js', { id: btn.dataset.lineKey, quantity: 0 });
    }).catch(function (err) {
      // Half-done is a different message from not-done. Saying "your cart
      // has not changed" when the 12 Pack was added would be untrue, so
      // report what actually happened and redraw the drawer to show it.
      if (added) {
        err.partial = true;
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          announce(cart);
          throw err;
        });
      }
      throw err;
    }));
  });
})();
